export default "__VITE_ASSET__34515ab0__"